import { render, staticRenderFns } from "./HomeAfiliados.vue?vue&type=template&id=7d9c2e47"
import script from "./HomeAfiliados.vue?vue&type=script&lang=ts"
export * from "./HomeAfiliados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports